import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ServerService} from '../../services/ServerService';

@Injectable({providedIn: 'root'})
export class FaturaAvulsaPublicaService extends ServerService {
  constructor(http: HttpClient) { super(http); }

  obtenha(codigo: string): Promise<any> {
    return this.http.get(`/api/faturas-avulsas/celcoin/${encodeURIComponent(codigo)}`)
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  sincronize(codigo: string): Promise<any> {
    return this.http.post(`/api/faturas-avulsas/celcoin/${encodeURIComponent(codigo)}/sincronizar`, {})
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  pagueComCartao(codigo: string, cartao: any, chave: string): Promise<any> {
    const headers = new HttpHeaders({'Idempotency-Key': chave});
    return this.http.post(`/api/faturas-avulsas/celcoin/${encodeURIComponent(codigo)}/cartao`, {cartao}, {headers})
      .toPromise().then(this.retorno).catch(this.handleError);
  }
}
